export * from './events';
export * from './propTypes';
export * from './routes';
export * from './testing';

export const dataRefreshInterval = 15000;



// WEBPACK FOOTER //
// ./src/constants/index.js